module.exports = __webpack_public_path__ + "img/people-44-min.0aaacb64.png";